import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  AudioOutlined,
  BarChartOutlined,
  ContactsOutlined,
  DollarOutlined,
  FlagOutlined,
  FundOutlined,
  IdcardOutlined,
  LineChartOutlined,
  MailOutlined,
  NotificationOutlined,
  PhoneOutlined,
  SendOutlined,
  StopOutlined,
} from '@ant-design/icons';
import PageHeader from '../Common/PageHeader/PageHeader';
import { updateDocumentTitle } from '../../utils/documentTitle';
import './AdminHubPage.css';

/**
 * AdminHubPage: /admin, the "More" of the admin menu (Nitish, Sep 16 2026 03:00-03:09 ET,
 * ruled off a wireframe: HubSpot-style hub; Users and Chats stay in the menu, everything else
 * is a card here; each card opens its page inside the app). V0 view re-ruled Sep 16 11:44 ET:
 * the mock's card grid, each card = icon + name + one-liner, NO counts/chips, one flat list, no
 * groups. Icons = antd Outlined, the same set the admin menu uses. Adding a spoke = one entry in
 * ADMIN_SPOKES; the card's page keeps its own route. Record: Maeve, work/admin_hub/, CEL-2721.
 */
export const ADMIN_SPOKES = [
  { to: '/admin/scoreboard', name: 'Business Scoreboard', icon: BarChartOutlined, line: 'Product signups, web-engaged 24h, first hires. Hourly, same source as the 9am email.' },
  { to: '/admin/hirers', name: 'Hirer Accounts', icon: IdcardOutlined, line: 'Every external owner who hired an AI employee, what they run, what they paid.' },
  { to: '/admin/payments', name: 'Payments', icon: DollarOutlined, line: "Who's paying and how, weekly: new subscriptions, renewals, top-ups, the first-month offer funnel." },
  { to: '/admin/marketing-pages', name: 'Marketing Pages', icon: FundOutlined, line: 'How each marketing page turns visitors into signups and payers, weekly, with and without agent users.' },
  { to: '/admin/referrals', name: 'Referral Fraud', icon: FlagOutlined, line: 'Fraud flags, review and resolve; referral program controls.' },
  { to: '/admin/leads', name: 'Leads', icon: ContactsOutlined, line: 'Contact-page and role-modal leads, with status.' },
  { to: '/admin/announcements', name: 'AI Employee Announcements', icon: NotificationOutlined, line: 'Broadcasts to every AI employee, with revoke.' },
  { to: '/admin/blocked-domains', name: 'Blocked Domains', icon: StopOutlined, line: 'Abuse clusters and the block list.' },
  { to: '/admin/phone-rates', name: 'Phone Rates', icon: PhoneOutlined, line: 'The carrier price matrix for numbers and calls, its history, the weekly reconciliation.' },
  { to: '/admin/lifecycle', name: 'Lifecycle Controls', icon: MailOutlined, line: 'Lifecycle email cells, countries, backfills, the daily dashboard.' },
  { to: '/admin/lifecycle-emails', name: 'Lifecycle Emails', icon: LineChartOutlined, line: 'Every lifecycle email sent, opens and clicks, negatives; signups held by country. Live from production.' },
  { to: '/admin/outreach', name: 'Outreach Ledger', icon: SendOutlined, line: 'Every cold send, rendered on click.' },
  { to: '/admin/blog-calls', name: 'Blog calls', icon: AudioOutlined, line: 'Every conversation a reader had with an employee on a blog post, with its transcript.' },
];

const AdminHubPage = () => {
  useEffect(() => { updateDocumentTitle('Admin'); }, []);
  return (
    <div className="adm-page adm-hub">
      <PageHeader title="Admin" subtitle="Users, Chats and AI employees live in the menu. Everything else is here; each card opens its own page." />
      <ul className="adm-hub-grid">
        {ADMIN_SPOKES.map((s) => {
          const Icon = s.icon;
          return (
            <li key={s.to}>
              <Link className="adm-hub-card" to={s.to} data-testid={`adm-hub-${s.to.split('/').pop()}`}>
                <span className="adm-hub-top">
                  <span className="adm-hub-ico" aria-hidden="true"><Icon /></span>
                  <span className="adm-hub-name">{s.name}</span>
                </span>
                <span className="adm-hub-line">{s.line}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AdminHubPage;
